import { cn } from '../../utils/cn';

export interface NetworkArtworkProps {
  className?: string;
}

/* A small logistics network: nodes on a route, drawn once as fixed coordinates so the picture is stable. */
const NODES: Array<[number, number, number]> = [
  [60, 300, 5],
  [180, 210, 4],
  [300, 260, 7],
  [420, 150, 4],
  [540, 220, 5],
  [660, 120, 6],
  [780, 200, 4],
  [250, 400, 4],
  [470, 380, 5],
  [700, 350, 4],
];
const EDGES: Array<[number, number]> = [
  [0, 1],
  [1, 2],
  [2, 3],
  [3, 4],
  [4, 5],
  [5, 6],
  [2, 7],
  [7, 8],
  [8, 9],
  [4, 8],
  [9, 6],
];

/**
 * Subtle network artwork for the auth brand panel: nodes and lanes in the current text colour at low
 * opacity, a highlighted lane in the accent. Pure SVG, no image files; sized by its container.
 */
export function NetworkArtwork({ className }: NetworkArtworkProps) {
  return (
    <svg aria-hidden viewBox="0 0 840 480" preserveAspectRatio="xMidYMid slice" className={cn('zo-network-artwork h-full w-full', className)}>
      <defs>
        <pattern id="zo-network-grid" width="40" height="40" patternUnits="userSpaceOnUse">
          <path d="M40 0H0V40" fill="none" stroke="currentColor" strokeOpacity="0.06" />
        </pattern>
      </defs>
      <rect width="840" height="480" fill="url(#zo-network-grid)" />
      <g stroke="currentColor" strokeOpacity="0.22" strokeWidth="1.5" fill="none">
        {EDGES.map(([a, b]) => (
          <line key={`${a}-${b}`} x1={NODES[a]![0]} y1={NODES[a]![1]} x2={NODES[b]![0]} y2={NODES[b]![1]} />
        ))}
      </g>
      <polyline points="60,300 180,210 300,260 420,150 540,220 660,120" fill="none" className="stroke-accent" strokeWidth="2.5" strokeOpacity="0.9" strokeDasharray="6 10" strokeLinecap="round" />
      <g fill="currentColor" fillOpacity="0.55">
        {NODES.map(([x, y, r], i) => (
          <circle key={i} cx={x} cy={y} r={r} />
        ))}
      </g>
      <g className="fill-accent">
        <circle cx="420" cy="150" r="9" fillOpacity="0.25" />
        <circle cx="420" cy="150" r="4" />
      </g>
    </svg>
  );
}
